import config from 'config';

import Fetch from 'tools/Fetch';

import {
    ENTITY_PATH,
} from '../constants';
import {
    IGetAccountStatisticDto,
} from '../requests/get-account-statistic.dto';
import {
    IGetAccountStatisticResponse,
} from '../responses/get-account-statistic.response';

export async function getAccountStatisticFetch(encodedId: string, dto: IGetAccountStatisticDto): Promise<IGetAccountStatisticResponse> {
    return new Fetch<IGetAccountStatisticResponse>({
        url: `${config.CRM_BACKEND_URL}/${ENTITY_PATH}/${encodedId}`,
        method: 'GET',
        query: dto,
    })
        .on([200], (body) => {
            return body;
        })
        .on([400, 401, 404, 500], (body) => {
            return body;
        })
        .exec();
}
